var map = {
	"./cap.svg": 95,
	"./cardigan.svg": 96,
	"./coat.svg": 97,
	"./gloves.svg": 98,
	"./icon.svg": 99,
	"./jacket.svg": 100,
	"./panties.svg": 101,
	"./parkaCoat.svg": 102,
	"./sandals.svg": 103,
	"./shirt.svg": 104,
	"./shoes.svg": 105,
	"./shortShorts.svg": 106,
	"./shortSleeveShirt.svg": 107,
	"./shorts.svg": 108,
	"./socks.svg": 109,
	"./sweater.svg": 110,
	"./tShirt.svg": 111,
	"./thickShirt.svg": 112,
	"./thickSocks.svg": 113,
	"./thickTrousers.svg": 114,
	"./thinShirt.svg": 115,
	"./thinTrousers.svg": 116,
	"./trousers.svg": 117,
	"./tubeTop.svg": 118,
	"./underpants.svg": 119,
	"./undershirt.svg": 120,
	"./vest.svg": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;